export default {"src":"/_next/static/media/instagram.dea82c2d.svg","height":601,"width":601,"blurWidth":0,"blurHeight":0};